import { useSyncExternalStore } from 'react';
import { seja } from '../seja/seja';

/**
 * Zaklep instance zaradi neplačane naročnine: strežnik vrne 403 NAROCNINA_POTEKLA (fetchZSejo to zabeleži), okvir nato
 * vsak zaslon preusmeri na Naročnino. Odklene se, ko zaslon Naročnina dobi stanje brez zaklepa (po plačilu) ali ob
 * odjavi.
 */
let sporocilo: string | null = null;
const poslusalci = new Set<() => void>();

function nastavi(s: string | null) {
  if (s !== sporocilo) {
    sporocilo = s;
    poslusalci.forEach((p) => p());
  }
}

export const zaklep = {
  dobi: () => sporocilo,
  zakleni: (s: string) => nastavi(s),
  odkleni: () => nastavi(null),
  naroci: (p: () => void) => {
    poslusalci.add(p);
    return () => poslusalci.delete(p);
  },
};

seja.naroci(() => {
  if (seja.dobi().status !== 'prijavljen') {
    nastavi(null);
  }
});

/** Sporočilo zaklepa ali {@code null}. */
export function useZaklep(): string | null {
  return useSyncExternalStore(zaklep.naroci, zaklep.dobi);
}

/** Iz odgovora 403 prebere, ali gre za zaklep naročnine (telo ostane neprebrano za klicatelja). */
export async function preveriZaklep(odgovor: Response): Promise<void> {
  if (odgovor.status !== 403) {
    return;
  }
  try {
    const telo = (await odgovor.clone().json()) as { koda?: string; sporocilo?: string };
    if (telo.koda === 'NAROCNINA_POTEKLA') {
      zaklep.zakleni(telo.sporocilo ?? 'Naročnina je potekla.');
    }
  } catch {
    // ni JSON – ni zaklep
  }
}
